.root {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  height: 32px;

  .left {
    padding: 0px 14px;
    display: flex;
    align-items: center;
    gap: 16px;

    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
    }
  }

  .right {
    display: flex;
    align-items: center;
    gap: 3px;
  }
}

.actionIconButton {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;

  &:hover:not(.disabled) {
    background-color: var(--dark-5);
  }

  &.disabled {
    opacity: 0.3;
    pointer-events: none;
  }
}
